import colors from '../../constants/colors'
import { IFilterObject } from '../FilterComponent'

const defaultFilter: IFilterObject[] = [
  {
    title: 'Media',
    value: 'media_type',
    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Audio',
        value: 'AUDIO',
        checked: false,
        section: false,
      },
      {
        title: 'Video',
        value: 'VIDEO',
        checked: false,
        section: false,
      },
      {
        title: 'Image',
        value: 'IMAGE',
        checked: false,
        section: false,
      },
      {
        title: 'PDF',
        value: 'DOCUMENT',
        checked: false,
        section: false,
      },
    ],
  },
]

const sectionNames: { [key: string]: string } = {
  persons: 'Person',
  media_type: 'Media',
}

const customChipStyle = {
  backgroundColor: colors.TAG_GRAY_FILL,
  border: `1px solid ${colors.TAG_LINES_GRAY}`,
  borderRadius: '3px',
}

export default {
  defaultFilter,
  sectionNames,
  customChipStyle,
}
